module.exports = __webpack_public_path__ + "static/media/thrifter-deals-cms.0bb1eb84.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Services/img/thrifter-deals-cms.png
// module id = 181
// module chunks = 0